// extracted by mini-css-extract-plugin
export var backdropBlur = "_ki-0";
export var contentCard = "_ki-5";
export var frame = "_ki-2";
export var image = "_ki-4";
export var imagePane = "_ki-3";
export var modal = "_ki-1";